import { render, staticRenderFns } from "./classificationEdit.vue?vue&type=template&id=19b14d09&"
import script from "./classificationEdit.vue?vue&type=script&lang=js&"
export * from "./classificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./classificationEdit.vue?vue&type=style&index=0&id=19b14d09&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports